module.exports = __webpack_public_path__ + "static/media/001.4b1ef338.jpg";